/**
 * Включает zustand `devtools` middleware только в development.
 *
 * При `enabled: true` без установленного Redux DevTools Extension middleware
 * на каждый store при инициализации пишет в консоль:
 * «Please install/enable Redux devtools extension».
 */
export const isZustandDevtoolsEnabled = process.env.NODE_ENV !== "production";
